import isClip from "src/constants/isClip";
import native from "src/constants/native";
import getUniqueTypes from "../../helpers/getUniqueTypes";
import isValidDataTypes from "../../helpers/isValidDataTypes";
import { PickSharePayloadData, SharePayloadData } from "../../types";

const SupportedShareIMessageFormats = ["Text", "Url", "Image", "LivePhoto"] as const;

export type ShareIMessageDataType = PickSharePayloadData<typeof SupportedShareIMessageFormats>;

export const isValidShareIMessagePayload = (
	data: SharePayloadData,
	{
		isSmsAvailable,
	}: {
		isSmsAvailable: boolean;
	},
): data is ShareIMessageDataType => {
	return (
		native &&
		!isClip &&
		isSmsAvailable &&
		// Text and url only if there's only one item
		((data.length === 1 &&
			isValidDataTypes(SupportedShareIMessageFormats, getUniqueTypes(data))) ||
			isValidDataTypes(
				["Image", "LivePhoto"] satisfies (typeof SupportedShareIMessageFormats)[number][],
				getUniqueTypes(data),
			))
	);
};
